import { InheritableType } from './is-inheritable.model';


export function getInheritableTypeAsEdited(inheritableType: InheritableType): InheritableType {
  switch (inheritableType) {
    case 'empty':
      return 'set';
    case 'inherited':
    case 'inherited-overridden':
      return 'overridden';
    default:
      return inheritableType;
  }
}


export function getInheritableTypeFromList(inheritableTypeList: InheritableType[]): InheritableType {
  const nonEmptyInheritableTypeList = inheritableTypeList.filter(inheritableType => inheritableType !== 'empty');

  if (nonEmptyInheritableTypeList.length === 0) {
    return 'empty';
  }

  if (nonEmptyInheritableTypeList.some(inheritableType => inheritableType === 'overridden')) {
    return 'overridden';
  }

  if (nonEmptyInheritableTypeList.some(inheritableType => inheritableType === 'inherited-overridden')) {
    return 'inherited-overridden';
  }

  if (nonEmptyInheritableTypeList.every(inheritableType => inheritableType === 'set')) {
    return 'set';
  }

  if (nonEmptyInheritableTypeList.every(inheritableType => inheritableType === 'inherited')) {
    return 'inherited';
  }

  return 'overridden';
}
